window.MT_PRICE_CALCULATORS_DEBUG = false;

// Main Price Calculator Logic
(() => {
	document.addEventListener('DOMContentLoaded', initPricingCalculators);
	document.addEventListener('shopify:section:load', initPricingCalculators);

	const initiatedInstances = [];

	function initPricingCalculators() {
  

		if (!window?.MT_PRICE_CALCULATORS || !Array.isArray(window.MT_PRICE_CALCULATORS) || initiatedInstances.includes(window.MT_PRICE_CALCULATORS?.id)) {
			console.log('No price calculators found');
			return;
		}

		window.MT_PRICE_CALCULATORS.forEach(initInstance);
	}

	function initInstance(calculatorData) {
		if (typeof calculatorData !== 'object' || !calculatorData?.id) {
			console.log('Invalid price calculator data');
			return;
		}

		const selectors = {
			bathroomsInput: '#dispensers',
			peopleInput: '#refills',

			dispenserQuantityElement: '.product-list--container.dispensers .total--quantity #dispenser-quantity',
			refillQuantityElement: '.product-list--container.refills .total--quantity #refills-quantity',

			dispenserTotalPrice: '.product-list--container.dispensers .total--price #dispenser-total',
			refillTotalPrice: '.product-list--container.refills .total--price #refills-total',
			upsellTotalPrice: '.upsell--container .total--price #upsell-total',
			combinedTotalPrice: '.total--combined--price #combined-total',

			dispensersRecommended: ".product-list--container.dispensers #dispensers-recommended",
			refillsRecommended: ".product-list--container.refills #refills-recommended",

			refillsBathrooms: ".product-list--container.refills #refills-bathrooms",
			refillsPeople: ".product-list--container.refills #refills-people",

			resultsContainer: ".your--results",
			resultsBathrooms: ".your--results #results-bathrooms",
			resultsPeople: ".your--results #results-people",

			recalculateButton: '.recalculate--container .recalculate--button',
			addToCartButton: '.add-to-cart--button',
			addToCartDisabledText: '.add-to-cart--disabled--text',

			quantityInputs: '.quantity--selector input[type="number"]',
			quantityMinuses: '.quantity--selector .minus',
			quantityPluses: '.quantity--selector .plus',

			productInput: '.quantity--selector input',
			quantitySelector: '.quantity--selector',
			dispensersPlus: '.product-list--container.dispensers .quantity--selector .plus',
			refillsPlus: '.product-list--container.refills .quantity--selector .plus',

			dispenserQuantityInput: '.product-list--container.dispensers .product--item .quantity--selector input',
			refillQuantityInput: '.product-list--container.refills .product--item .quantity--selector input',

			dispenserProductItems: '.product-list--container.dispensers .product--item',
			refillProductItems: '.product-list--container.refills .product--item',
			productItems: '.product-list--container .product--item',
			upsellItems: '.upsell--container .upsell-product',

			stepsContainerAnchor: 'calculator--steps--anchor--',
			productList: '.product-list--container .product--list',

			sellingPlanOptionsSelect: '.options--container select',
			sellingPlanSelectedSubscription: '.selling-plan--container .button--group button.subscribe.selected',

			citronDisclaimer: '.citron--disclaimer',
			bookCall: '.book-a-call',

			upsellProductsContainer: '.upsell-product--container',

			summaryContainer: '.total--combined--price',

			dispensersSummary: '.summary--products .step-1--summary',
			refillsSummary: '.summary--products .step-2--summary',
			upsellsSummary: '.summary--products .step-3--summary',

			summaryHeading: '.summary--products .step--total',
			summaryProducts: '.summary--products .step--products',

			formBanner: '.generic--banner',

			stepsSliderContainer: '.price-calculator--container .steps--slider',

			queryParams: {
				bathrooms: 'how_many_bathrooms_does_your_organization_have_',
				people: 'how_many_people_with_periods_does_your_organization_have_',
				jobTitle: 'which_title_best_describes_your_role_',
				industry: 'industry_type___gaq_form',
				country: 'country_region___citron_leads',
				taxExempt: 'are_you_tax_exempt_',
			}
		}

		const operations = {
			"=": (a, b) => a.toLowerCase() === b.toLowerCase(),
			"!=": (a, b) => a.toLowerCase() !== b.toLowerCase(),
			"<": (a, b) => Number(a) < Number(b),
			">": (a, b) => Number(a) > Number(b),
			"in": (a, b) => b.some(item => item.toLowerCase() === a.toLowerCase()),
			"not in": (a, b) => !b.some(item => item.toLowerCase() === a.toLowerCase()),
		};

		const isB2B = document.body.classList.contains("b2b_customer");
		const calculatorContainer = document.getElementById(calculatorData.id);

		let stepsSwiper;

		if (!calculatorContainer) {
			console.log('No price calculator container found');
			return;
		}

		handleQueryParams();

		initEventListeners();

		initiatedInstances.push(calculatorData.id);

		initializeSlider();
		document.addEventListener('shopify:section:load', initializeSlider);

		normalizeTitleHeights();
		window.addEventListener('resize', normalizeTitleHeights);

		function initializeSlider() {
			// TODO: Refactor to use selectors object
			const stepsSliderContainer = document.querySelector('.price-calculator--container .steps--slider');
			const stepsPage = stepsSliderContainer.querySelector('.step-count .page');
			const stepsPagination = stepsSliderContainer.querySelector('.swiper-pagination');
			const stepsNextButton = stepsSliderContainer.querySelector('.price-calculator--container .steps--slider .navigation-button-next');
			const stepsPrevButton = stepsSliderContainer.querySelector('.price-calculator--container .steps--slider .navigation-button-prev');

			const animation = calculatorData?.steps_animation || '';
			const stepsNextText = calculatorData?.steps_next_text || 'go to next step';
			const addToCartText = calculatorData?.add_to_cart_text || 'add order to cart';

			const calculatorId = calculatorData?.id;

			const sellingPlanButtons = document.querySelectorAll('.selling-plan--container .button--group button');

			console.log("Animation", animation);

			if (!stepsSliderContainer) {
				return;
			}

			if (stepsSwiper) {
				stepsSwiper.destroy(true, true);
			}

			stepsSwiper = new Swiper(stepsSliderContainer, {
				slidesPerView: 1,
				spaceBetween: 150,
				loop: false,
				autoHeight: true,
				drag: false,
				allowTouchMove: false,
				effect: animation || '',
				navigation: {
					nextEl: stepsNextButton,
					prevEl: stepsPrevButton,
				},
				pagination: {
					el: '.price-calculator--container .steps--slider .swiper-pagination',
					clickable: true,
				},
			});

			updateStepsPage(stepsSwiper);

			stepsSwiper.on('slideChangeTransitionStart', () => {
				const stepsContainerAnchor = document.getElementById(selectors.stepsContainerAnchor + calculatorId);

				if (stepsContainerAnchor) {
					stepsContainerAnchor.scrollIntoView({behavior: 'smooth'});

					console.log('Scrolling to anchor');
				}
			})

			stepsSwiper.on('slideChange', () => {
				
				updateStepsPage(stepsSwiper);

				const isLastSlide = stepsSwiper.realIndex === stepsSwiper.slides.length - 1;

				stepsNextButton.textContent = isLastSlide ? addToCartText : stepsNextText;
				stepsNextButton.classList.toggle('is_last_step', isLastSlide);

				if (isLastSlide) {
					stepsNextButton.disabled = !stepsNextButton.classList.contains('valid');
				}

				const addToCartDisabledText = calculatorContainer.querySelector(selectors.addToCartDisabledText);

				if (addToCartDisabledText) {
					addToCartDisabledText.classList.toggle('show', isLastSlide && !stepsNextButton.classList.contains('valid'));
				}

				const paginationBullets = stepsPagination.querySelectorAll('.swiper-pagination-bullet');

				paginationBullets.forEach((bullet, index) => {
					if (index < stepsSwiper.realIndex) {
						bullet.classList.add('completed');

						return;
					}

					bullet.classList.remove('completed');
				});
			});

			// When button is clicked, refresh the swiper since the height might change
			sellingPlanButtons && sellingPlanButtons.forEach(button => {
				button.addEventListener('click', () => {
					setTimeout(() => {
						stepsSwiper.update();
					}, 100);
				});
				$('.selling-plan--container').each(function () {
    const $subscribeBtn = $(this)
      .find('.button--group button[data-is-subscription="true"]')
      .first();

    if ($subscribeBtn.length) {
      $subscribeBtn.trigger('click');
    }
  });
			});

			function updateStepsPage(swiper) {
				if (!stepsPage) {
					return;
				}

				stepsPage.textContent = `${swiper.realIndex + 1} of ${swiper.slides.length}`;
			}
		}

		function handleQueryParams() {
			const bathroomsInput = calculatorContainer.querySelector(selectors.bathroomsInput);
			const peopleInput = calculatorContainer.querySelector(selectors.peopleInput);

			const queryParams = new URLSearchParams(window.location.search);
			const formData = {
				bathrooms: Number(queryParams.get(selectors.queryParams.bathrooms) || 1),
				people: Number(queryParams.get(selectors.queryParams.people) || 10),
				country: queryParams.get(selectors.queryParams.country),
				taxExempt: queryParams.get(selectors.queryParams.taxExempt)
			}

			const formBanners = calculatorContainer.querySelectorAll(selectors.formBanner);

			formBanners.forEach(banner => {
				const { advancedRules, dynamicLinks } = banner.dataset;

				if (dynamicLinks) {
					try {
						const parsedDynamicLinks = JSON.parse(dynamicLinks);
						const jobTitleParam = queryParams.get(selectors.queryParams.industry);

						if (parsedDynamicLinks?.length > 0 && jobTitleParam) {
							parsedDynamicLinks.find(linkData => {
								const { link, query_value } = linkData;

								if (!link || !query_value) {
									return false;
								}

								if (query_value === jobTitleParam) {
									banner.querySelector('a.btn')?.setAttribute('href', link);
									return true;
								}
							});
						}
					}

					catch (e) {
						console.error('Error parsing dynamic links:', e);
					}
				}

				if (advancedRules) {
					try {
						const parsedRules = JSON.parse(advancedRules);

						if (parsedRules) {
							const { rules, combinator } = parsedRules;

							const isExclusionOperation = combinator === 'none';

							const evaluateRule = (rule) => {
								const { query, value, operation } = rule;
								const queryData = queryParams.get(query);

								const isValidData = queryData && value && operation;
								const isExistingOperation = Object.keys(operations).includes(operation);

								const isEqualityOperation = operation === '=' || operation === 'in' || operation === 'not in' || operation === '!=';
								const isInclusionOperation = operation === 'in' || operation === 'not in';

								const isValidEqualityOperation = isEqualityOperation || !isNaN(Number(value));
								const isValidInclusionOperation = !isInclusionOperation || Array.isArray(value);

								if (!isValidData || !isExistingOperation || !isValidEqualityOperation || !isValidInclusionOperation) {
									return false;
								}

								return operations[operation]?.(queryData, value) ?? false;
							}

							const shouldShow = combinator === 'all'
								? rules.every(evaluateRule)
								: rules.some(evaluateRule);

							banner.classList.toggle('show', isExclusionOperation ? !shouldShow : shouldShow);
						}
					}

					catch (e) {
						console.error('Error parsing advanced rules, falling back to simple rules:', e);
					}
				}

				else {
					const operation = banner.dataset.operation;
					const queryName = banner.dataset.queryName || '';
					const queryValue = banner.dataset.queryValue;

					const queryData = queryParams.get(queryName);

					if (!queryData || !queryName || !queryValue || !operation || ((operation !== '=' && operation !== '!=') && isNaN(Number(queryValue)))) {
						console.log('Invalid data for banner:', queryData, queryName, queryValue, operation);
						return;
					}

					const isMatching = operations[operation]?.(queryData, queryValue) ?? false;

					console.log('Banner data:', queryData, queryName, queryValue, operation, isMatching);

					banner.classList.toggle('show', isMatching);
				}
			});

			bathroomsInput.value = formData.bathrooms;
			peopleInput.value = formData.people;

			calculateRecommendedUI();

			if (window.MT_PRICE_CALCULATORS_DEBUG) {
				try {
					formBanners.forEach(banner => {
						banner.classList.add('force-show');
					});
				} catch (e) {
					console.error('Error parsing query params:', e);
				}
			}
		}

		function initEventListeners() {
			const productQuantitySelectors = calculatorContainer.querySelectorAll(selectors.quantitySelector);
			const optionsSelects = calculatorContainer.querySelectorAll(selectors.sellingPlanOptionsSelect);
			const productItems = calculatorContainer.querySelectorAll(selectors.productItems);

			const recalculateButton = calculatorContainer.querySelector(selectors.recalculateButton);
			const addToCartButton = calculatorContainer.querySelector(selectors.addToCartButton);

			console.log('productQuantitySelectors', productQuantitySelectors);

			productQuantitySelectors.forEach(initQuantityEventListeners);

			optionsSelects.forEach(initOptionsEventListeners);
			productItems.forEach(initSubscriptionSelectorEventListeners);

			recalculateButton.addEventListener('click', handleRecalculate);
			addToCartButton.addEventListener('click', handleAddToCart);
		}

		function initQuantityEventListeners(quantitySelector) {
			const input = quantitySelector.querySelector('input');
			const productMinus = quantitySelector.querySelector(`.minus`);
			const productPlus = quantitySelector.querySelector(`.plus`);

			if (!productMinus || !productPlus || !input) {
				return;
			}

			input.addEventListener('input', handleQuantityInput);

			productMinus.addEventListener('click', () => {
				if (productMinus.classList.contains('disabled')) {
					return;
				}

				handleQuantityClick(-1);
			});

			productPlus.addEventListener('click', () => handleQuantityClick(1));

			function handleQuantityInput() {
				input.value = clamp(input.value);

				calculateRecommendedUI();

				const isRefill = quantitySelector.closest('.product-list--container.refills');

				if (isRefill) {
					const parentProductItem = quantitySelector.closest('.product--item');

					calculatePricePerYear(parentProductItem, input);
				}
			}

			function handleQuantityClick(delta = 1) {
				const productInput = quantitySelector.querySelector('input');

				if (!productInput) {
					return;
				}

				const isRefill = quantitySelector.closest('.product-list--container.refills');
				const value = Number(productInput.value || 0);
				const minValidValue = delta > 0 ? 1 : 0;

				productInput.value = clamp(value + delta, minValidValue);
				productMinus.classList.toggle('disabled', Number(productInput.value) === 0);

				calculateRecommendedUI();

				if (isRefill) {
					const parentProductItem = quantitySelector.closest('.product--item');

					calculatePricePerYear(parentProductItem, productInput);
				}
			}
		}

		function initOptionsEventListeners(optionsSelect) {
			const parentProductItem = optionsSelect.closest('.product--item');
			const productInput = parentProductItem.querySelector('.quantity--selector input');

			optionsSelect.addEventListener('change', () => calculatePricePerYear(parentProductItem, productInput));
			optionsSelect.addEventListener('change', () => {
	const selectedOption = optionsSelect.options[optionsSelect.selectedIndex];
	const planPrice = Number(selectedOption.dataset.price);
	const parentProductItem = optionsSelect.closest('.product--item');

	console.log('[PLAN CHANGE]', {
		planId: selectedOption.value,
		planPrice
	});

	if (parentProductItem && planPrice) {
		parentProductItem.dataset.price = planPrice;
		updateVisiblePrice(parentProductItem, true, planPrice);
	}

	calculatePricePerYear(parentProductItem, productInput);
	calculateRecommendedUI();
});
		}

		function initSubscriptionSelectorEventListeners(productItem) {
			const sellingPlanContainer = productItem.querySelector('.selling-plan--container');

			if (!sellingPlanContainer) {
				return;
			}

			const buttonGroupButtons = Array.from(sellingPlanContainer.querySelectorAll('.button--group button'));
			const optionsContainerSelect = sellingPlanContainer.querySelector('.options--container select');

			if (!buttonGroupButtons || !optionsContainerSelect) {
				return;
			}

		buttonGroupButtons.forEach((button) => {
	button.addEventListener('click', () => {
		const parentProductItem = sellingPlanContainer.closest('.product--item');
		const pricePerYearContainer = sellingPlanContainer.querySelector('.price--per-year');
		const optionsContainer = sellingPlanContainer.querySelector('.options--container');

		const isSubscription = button.dataset.isSubscription === 'true';
		const price = Number(button.dataset.price);

		console.log('[PURCHASE MODE]', {
			isSubscription,
			price
		});

		if (parentProductItem && price) {
			parentProductItem.dataset.price = price;
			updateVisiblePrice(parentProductItem, isSubscription, price);
		}

		buttonGroupButtons.forEach((btn) =>
			btn.classList.toggle('selected', btn === button)
		);

		pricePerYearContainer.classList.toggle('show', isSubscription);
		optionsContainer.classList.toggle('show', isSubscription);

		calculateRecommendedUI();
	});
});

		optionsContainerSelect.addEventListener('change', () => {
	const sellingPlanId = optionsContainerSelect.value;

	// 🔥 IMPORTANT: get the correct refill product
	const productItem = optionsContainerSelect.closest('.product--item');

	if (!sellingPlanId || !productItem) {
		console.warn('[SELLING PLAN NOT SET]', {
			sellingPlanId,
			productItem
		});
		return;
	}

	// ✅ persist selling plan on the refill item itself
	productItem.dataset.sellingPlanId = sellingPlanId;

	console.log('[SELLING PLAN SAVED]', {
		productId: productItem.dataset.productId,
		sellingPlanId
	});
});


		}

		function handleRecalculate() {
			clearSelections();
			calculateRecommendedUI();

			const resultsContainer = calculatorContainer.querySelector(selectors.resultsContainer);
			resultsContainer.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			})
		}
		function updateVisiblePrice(productItem, isSubscription, price) {
    const oneTimePriceEl = productItem.querySelector('.product--price'); 
	const subscriptionPriceEl = productItem.querySelector('.product--price-subscription');

    console.log('[PRICE UI UPDATE]', {
        isSubscription,
        price
    });

    if (!oneTimePriceEl) return;

    if (isSubscription && subscriptionPriceEl) {
        // Show both prices, but strikethrough one-time
        oneTimePriceEl.classList.add('compare--at');
        subscriptionPriceEl.style.display = 'inline';
        subscriptionPriceEl.textContent = `$${(price / 100).toFixed(2)}`;
    } else {
        // Normal display for one-time
        oneTimePriceEl.classList.remove('compare--at');
        subscriptionPriceEl.style.display = 'none';
        oneTimePriceEl.textContent = `$${(price / 100).toFixed(2)}`;
    }
}



		function handleAddToCart() {
			const addToCartButton = calculatorContainer.querySelector(selectors.addToCartButton);

			if (!addToCartButton.classList.contains('valid') || !addToCartButton.classList.contains('is_last_step')) {
				return;
			}

			addSelectionsToCart();

			if (isB2B) {
				setTimeout(() => {
					document.dispatchEvent(new CustomEvent('theme:cart:custom:update'));
					window.location = '/cart';
				}, 2000);
			}
		}

		function addSelectionsToCart() {
			console.log('Adding items to cart');

			const dispensersWithQuantity = getSelectedItems(selectors.dispenserProductItems);
			const refillsWithQuantity = getSelectedItems(selectors.refillProductItems);
			const upsellsWithQuantity = getSelectedItems(selectors.upsellItems);

			dispensersWithQuantity.forEach(item => {
				addItemToCart(
						item.dataset.productId,
						item.querySelector(selectors.productInput).value
				);
			});

			refillsWithQuantity.forEach(item => {
	console.log('[ADDING REFILL]', {
		productId: item.dataset.productId,
		quantity: item.querySelector(selectors.productInput).value,
		sellingPlanId: item.dataset.sellingPlanId
	});

	addItemToCart(
		item.dataset.productId,
		item.querySelector(selectors.productInput).value,
		item.dataset.sellingPlanId || null
	);
});


			if (!upsellsWithQuantity.length) {
				return;
			}

			const upsellProductsContainer = calculatorContainer.querySelector(selectors.upsellProductsContainer);
			const discountCode = upsellProductsContainer?.dataset?.discountCode;

			upsellsWithQuantity.forEach(item => {
				addItemToCart(
						item.dataset.productId,
						item.querySelector(selectors.productInput).value,
						null,
						discountCode
				);
			});
		}

		function clearSelections() {
			const quantityInputs = calculatorContainer.querySelectorAll(selectors.quantityInputs);
			const quantityMinuses = calculatorContainer.querySelectorAll(selectors.quantityMinuses);
			const quantityPluses = calculatorContainer.querySelectorAll(selectors.quantityPluses);

			const dispensersTotalPrice = calculatorContainer.querySelector(selectors.dispenserTotalPrice);
			const refillsTotalPrice = calculatorContainer.querySelector(selectors.refillTotalPrice);

			if (!quantityInputs || !quantityMinuses || !quantityPluses || !dispensersTotalPrice || !refillsTotalPrice) {
				return;
			}

			quantityInputs.forEach(input => input.value = 0)
			quantityMinuses.forEach(minusButton => minusButton.classList.add('disabled'));
			quantityPluses.forEach(plusButton => plusButton.classList.remove('disabled'));

			dispensersTotalPrice.textContent = '$0.00';
			refillsTotalPrice.textContent = '$0.00';
		}

		function calculateRecommendedUI() {
			const bathroomsInput = calculatorContainer.querySelector(selectors.bathroomsInput);
			const peopleInput = calculatorContainer.querySelector(selectors.peopleInput);
			const summaryContainer = calculatorContainer.querySelector(selectors.summaryContainer);

			if (!bathroomsInput || !peopleInput || !summaryContainer) {
				return;
			}

			const bathroomsLabel = bathroomsInput.value + (bathroomsInput.value > 1 ? '\u00A0bathrooms' : '\u00A0bathroom');
			const peopleLabel = peopleInput.value + (peopleInput.value > 1 ? '\u00A0people' : '\u00A0person');

			const dispensersPer = calculatorData?.dispensers?.per || 1;
			const refillsPer = calculatorData?.refills?.per || 5;
			const minSuggestedQuantity = 2; // TODO: Make this dynamic via settings

			const dispenserProductList = calculatorData?.dispensers?.products || [];
			const refillProductList = calculatorData?.refills?.products || [];
			const upsellProductList = calculatorData?.upsells?.products || [];

			const dispensersRecommended = Math.max(dispensersPer * bathroomsInput.value, minSuggestedQuantity);
			const refillsRecommended = Math.max(Math.ceil(refillsPer * peopleInput.value / 500), minSuggestedQuantity);

			const totalPrices = {
				dispensers: getTotalPrice(selectors.dispenserProductItems),
				refills: getTotalPrice(selectors.refillProductItems),
				upsells: getTotalPrice(selectors.upsellItems),
			}

			const itemAmounts = {
				dispensers: getSelectedItemsAmount(selectors.dispenserProductItems),
				refills: getSelectedItemsAmount(selectors.refillProductItems),
				upsells: getSelectedItemsAmount(selectors.upsellItems),
			}

			const combinedTotal = Object.values(totalPrices).reduce((acc, total) => acc + total, 0);
			const combinedAmount = Object.values(itemAmounts).reduce((acc, amount) => acc + amount, 0);

			determineAddToCartValidity(minSuggestedQuantity);

			// Update UI
			updateElementText(selectors.resultsBathrooms, bathroomsLabel);
			updateElementText(selectors.resultsPeople, peopleLabel);

			updateElementText(selectors.refillsBathrooms, bathroomsLabel);
			updateElementText(selectors.refillsPeople, peopleLabel);

			updateSubTotalElement(selectors.dispenserTotalPrice, totalPrices.dispensers);
			updateSubTotalElement(selectors.refillTotalPrice, totalPrices.refills);
			updateSubTotalElement(selectors.upsellTotalPrice, totalPrices.upsells);
			updateSubTotalElement(selectors.combinedTotalPrice, combinedTotal);

			updatedRecommendedQuantity(dispensersRecommended, selectors.dispensersRecommended);
			updatedRecommendedQuantity(refillsRecommended, selectors.refillsRecommended, 500);

			updateRemainingQuantity(dispensersRecommended, itemAmounts.dispensers, selectors.dispenserQuantityElement);
			updateRemainingQuantity(refillsRecommended, itemAmounts.refills, selectors.refillQuantityElement);

			updateProductSummary(selectors.dispensersSummary, selectors.dispenserProductItems, dispenserProductList);
			updateProductSummary(selectors.refillsSummary, selectors.refillProductItems, refillProductList);
			updateProductSummary(selectors.upsellsSummary, selectors.upsellItems, upsellProductList, true);

			summaryContainer.classList.toggle('empty', combinedAmount <= 0);

			if (stepsSwiper) {
				stepsSwiper.update();
			}
		}

		function updateProductSummary(summarySelector, productItemsSelector, productList, isUpsell = false) {
			const summaryContainer = calculatorContainer.querySelector(summarySelector);
			const productItems = calculatorContainer.querySelectorAll(productItemsSelector);

			if (!summaryContainer || !productItems) {
				return;
			}

			const headingElement = summaryContainer.querySelector(selectors.summaryHeading);
			const productsElement = summaryContainer.querySelector(selectors.summaryProducts);

			if (!headingElement || !productsElement) {
				return;
			}

			const totalCount = getSelectedItemsAmount(productItemsSelector);
			const totalPrice = getTotalPrice(productItemsSelector);

			const selectedItems = getSelectedItems(productItemsSelector);

			summaryContainer.classList.toggle('show', totalCount > 0);
			headingElement.textContent = `${totalCount} selected (${formatPrice(totalPrice)})`;

			addProductToSummary(productsElement, selectedItems, productList, isUpsell);
		}

		function addProductToSummary(container, productItems, productList, isUpsell = false) {
    container.innerHTML = '';

    productItems.forEach(item => {
        const product = productList.find(p => p.id === item.dataset.productId);

        if (!product) return;

        const image = product.image || '';
        const name = product.title || '';
        const quantity = item.querySelector(selectors.productInput).value || 0;

        const livePrice = Number(item.dataset.price);
		const basePrice = product.price;
        let price = formatPrice(livePrice);
        let compareAtPrice = null;

        const isSubscription = item.querySelector('.selling-plan--container .subscribe.selected');

        // Subscription logic
        if (isSubscription && product.price && product.price !== livePrice) {
            compareAtPrice = formatPrice(product.price);
		price += ` <span class="compare--at">${compareAtPrice}</span>`;}
        // Add-on / upsell compare-at logic
        if (isUpsell && basePrice > livePrice) {
			const testprice = (basePrice/100).toFixed(2);
            compareAtPrice = formatPrice(product.compare_at_price);
 price += ` <span class="compare--at">${testprice}</span>`;
        }
        const productElement = document.createElement('li');
        productElement.classList.add('summary--item');

        productElement.innerHTML = `
            <div class="summary--image">
                <img src="${image}" alt="${name}">
            </div>
            <div class="summary--details">
                <div class="summary--name">${name}</div>
                <div class="summary--quantity">${quantity} @ ${price + (quantity > 1 ? ' each' : '')}</div>
            </div>
        `;

        const removeButton = document.createElement('button');
        removeButton.classList.add('remove--button');
        removeButton.addEventListener('click', () => {
            item.querySelector(selectors.productInput).value = 0;
            item.querySelector(selectors.productInput).dispatchEvent(new Event('input'));
        });

        productElement.appendChild(removeButton);
        container.appendChild(productElement);
    });
}


		function determineAddToCartValidity(min) {
			const addToCartButton = calculatorContainer.querySelector(selectors.addToCartButton);
			const addToCartDisabledText = calculatorContainer.querySelector(selectors.addToCartDisabledText);
			const bookCallBanner = calculatorContainer.querySelector(selectors.bookCall);

			if (!addToCartButton) {
				return;
			}

			const dispensersQuantity = getSelectedItemsAmount(selectors.dispenserProductItems);
			const refillsQuantity = getSelectedItemsAmount(selectors.refillProductItems);
			const isValidState = dispensersQuantity >= min && refillsQuantity >= min;

			addToCartButton.classList.toggle('valid', isValidState);
			// addToCartDisabledText.classList.toggle('show', !isValidState);

			if (bookCallBanner) {
				const bathroomsInput = calculatorContainer.querySelector(selectors.bathroomsInput);

				if (!bathroomsInput) return;

				bookCallBanner.classList.toggle('show', bathroomsInput.value > 5);
			}
		}

		function updatedRecommendedQuantity(recommended, selector, multiplier = 1) {
			if (isNaN(recommended)) {
				return;
			}

			updateElementText(selector, String(recommended * multiplier));
		}

		function updateRemainingQuantity(recommended, selectedAmount, quantitySelector) {
			if (isNaN(recommended) || isNaN(selectedAmount) || !quantitySelector) {
				return;
			}

			const remaining = Math.max(recommended - selectedAmount, 0);

			updateElementText(quantitySelector, String(remaining));
		}

		function updateSubTotalElement(selector, price) {
			if (isNaN(price)) {
				return;
			}

			updateElementText(selector, formatPrice(price));
		}

		function updateElementText(selector, text) {
			const element = calculatorContainer.querySelector(selector);

			if (!element) {
				return;
			}

			element.textContent = text;
		}

		function getTotalPrice(selector) {
			let total = 0;
			const productItems = calculatorContainer.querySelectorAll(selector);

			if (!productItems) {
				return total;
			}

			total = Array.from(productItems).reduce((acc, productItem) => {
				const productInput = productItem.querySelector(selectors.productInput);
				const productPrice = productItem.dataset.price;

				if (!productInput || !productPrice) {
					return;
				}

				acc += Number(productInput.value) * Number(productPrice);

				return acc;
			}, total);

			if (typeof total !== 'number') {
				return 0;
			}

			return total;
		}

		function calculatePricePerYear(parentProductItem, productInput) {
			const pricePerYearText = parentProductItem.querySelector('.price--per-year .price');
			const productPrice = (parentProductItem.dataset.price / 100).toFixed(2);
			const deliveryOptions = parentProductItem.querySelector('.options--container select');
			const deliveryOptionText = deliveryOptions.options[deliveryOptions.selectedIndex].text.replace('deliveryOption ', '').replace(' Month(s)', '');
			const pricePerYear = ((productPrice * productInput.value * (12 / parseInt(deliveryOptionText)))).toFixed(2);

			if (pricePerYearText) {
				pricePerYearText.textContent = `$${pricePerYear}`;
			}
		}

		function getSelectedItems(selector) {
			return Array.from(calculatorContainer.querySelectorAll(selector))
					.filter(item => item.querySelector(selectors.productInput).value > 0);
		}

		function getSelectedItemsAmount(selector) {
			return getSelectedItems(selector).reduce((acc, item) => acc + parseInt(item.querySelector(selectors.productInput).value), 0);
		}

		function addItemToCart(id, quantity, sellingPlan = null, discountCode = null) {
			if (sellingPlan) {
				console.log('Adding item to cart with selling plan:', id, quantity, sellingPlan);
			}

			const cart = window.Rebuy.Cart;

			if (!cart || !cart?.addItem || !id || !quantity || quantity < 1 || isNaN(quantity)) {
				return;
			}

			const data = {
				id,
				quantity,
				properties: {
					'source': 'price_calculator'
				}
			};

			if (discountCode) {
				applyDiscountCode(discountCode);
				data.properties['hasDiscount'] = true;
			}

			if (sellingPlan) {
				data.selling_plan = sellingPlan;
			}

			cart.addItem(data);
		}

		function applyDiscountCode(discountCode) {
			const cart = window.Rebuy.Cart;

			if (!discountCode || !cart) {
				return;
			}

			const fetchOptions = {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				}
			}

			cart.applyShopifyDiscount(discountCode);

			// Refresh
			fetch(`/checkout?discount=${discountCode}`, fetchOptions)
					.then((res) => {
						cart.fetchCart()
						return res.text();
					})
					.then((page) => {
						console.log('Discount code applied:', page);
					})
					.catch(error => console.error('Error fetching discount page:', error));
		}

		function formatPrice(value) {
			return `$${(value / 100).toFixed(2)}`;
		}

		function clamp(value, min = 0, max = 999) {
			if (isNaN(value)) {
				return 0;
			}

			return Math.min(Math.max(value, min), max);
		}

		function normalizeTitleHeights() {
			const containers = calculatorContainer.querySelectorAll(selectors.productList);

			if (!containers) {
				return;
			}

			setTimeout(() => {
				containers.forEach(container => {
					const titleElements = container.querySelectorAll('.product--item .product--title');

					if (!titleElements) {
						return;
					}

					let maxHeight = 0;

					titleElements.forEach(title => {
						title.style.height = 'auto';
						maxHeight = Math.max(title.clientHeight, maxHeight);
					});

					titleElements.forEach(title => {
						title.style.height = `${maxHeight}px`;
					});
				});
			}, 1500);
		}
	}
})();

//Adding Correct Selling Plan
$('.product--item').each(function () {
  const $item = $(this);

  // Subscribe button clicked
  $item.find('.button--group .subscribe').on('click', function () {
    const sellingPlanId = $item.find('.sellingPlan--select select').val();

    console.log('[SUBSCRIBE SELECTED]', {
      productId: $item.data('product-id'),
      sellingPlanId
    });

    $item.attr('data-selling-plan-id', sellingPlanId);
  });

  // One-time button clicked
  $item.find('.button--group .one-time').on('click', function () {
    console.log('[ONE TIME SELECTED]', {
      productId: $item.data('product-id')
    });

    $item.removeAttr('data-selling-plan-id');
  });

  // Plan dropdown changed
  $item.find('.sellingPlan--select select').on('change', function () {
    if ($item.find('.subscribe').hasClass('selected')) {
      console.log('[PLAN CHANGED]', {
        productId: $item.data('product-id'),
        sellingPlanId: this.value
      });

      $item.attr('data-selling-plan-id', this.value);
    }
  });
});


// Accordion Logic
(() => {
	document.addEventListener('DOMContentLoaded', () => {
		const accordionHeaders = document.querySelectorAll('.mega-section--container .accordion--header');

		if (!accordionHeaders) {
			return;
		}

		accordionHeaders.forEach(header => {
			header.addEventListener('click', () => {
				const content = header.nextElementSibling;

				accordionHeaders.forEach(h => {
					if (h !== header) {
						h.nextElementSibling.style.height = 0;
						h.classList.remove('open');
					}
				});

				if (!content) {
					return;
				}

				header.classList.toggle('open');
				content.style.height = header.classList.contains('open') ? `${content.scrollHeight}px` : 0;
			});
		});

		window.addEventListener('resize', () => {
			accordionHeaders.forEach(header => {
				if (header.classList.contains('open')) {
					header.nextElementSibling.style.height = '0';
					header.classList.remove('open');
				}
			});
		});
	});
})();
